import { DotChartOutlined } from "@ant-design/icons";
import { scatterplotCore } from "./core/scatterplot";
import { defineWidget } from "../widgetDefinition";
import { scatterplotSlots } from "../Slots";
import { scatterplotDuplicate } from "../Duplication/scatterplot";
import { scatterplotControlPanel } from "../ControlPanel/scatterplot";
import type { ScatterplotComponentSpec } from "../Processing/types";
import { ScatterplotWidget } from "../WidgetComponents/ScatterplotWidget";
import { ScatterplotInfo } from "../Info/scatterplot";
import { ScatterplotConfigurator } from "../AddWidgetModal/ScatterplotConfigurator";

export const scatterplotDefinition = defineWidget<ScatterplotComponentSpec>({
  ...scatterplotCore,
  type: "scatterplot",
  slots: scatterplotSlots,
  duplicate: scatterplotDuplicate,
  controlPanel: scatterplotControlPanel,
  info: { Content: ScatterplotInfo },
  schema: ["display", "xAxisMode", "xAxis", "yAxis", "widgetMutations", "scatterplot_builder_misc"],
  contractHash: "2b7gkqbsewi",
  needsData: true,

  template: {
    label: "Scatterplot",
    description: "Two metrics paired per athlete and day, with optional trendline",
    icon: <DotChartOutlined />,
  },

  defaultLayout: { w: 6, h: 12, minW: 3, minH: 4 },

  gridComponent: ({ id }) => <ScatterplotWidget id={id} />,

  configurator: {
    modalTitle: "Scatterplot",
    wide: true,
    Component: ScatterplotConfigurator as any,
  },
});
